<div class="bn-makepay-landing">
  <div [ngClass]="{ shows: isOneIncPayment, hides: !isOneIncPayment }">
    <div id="portalOneContainer" class="portalOneContainer"></div>
  </div>
  <div [ngClass]="{ shows: !isOneIncPayment, hides: isOneIncPayment }">
    <div class="bn-mkpay-title">Choose a payment method</div>
    <div class="bn-makepay-landing-text">
      Payments will first be applied to any prior remaining term balance. The
      minimum amount due and any outstanding balances are shown in the overview
      tab under “billing details.”
    </div>
    <ng-container *ngIf="policy?.billingDetails[0]?.badCheckCount === 'Y'">
      <div class="bn-notice-content">
        <app-bn-info-notice></app-bn-info-notice>
      </div>
    </ng-container>

    <div class="bn-notice-content" *ngIf="policy?.policyStatus === 'CANCELLED'">
      <app-bn-imp-notice [policy]="policy"></app-bn-imp-notice>
    </div>
    <div
      class="bn-notice-content"
      *ngIf="policy?.billingDetails[0]?.paymentMade"
    >
      <app-bn-alert-notice></app-bn-alert-notice>
    </div>
    <ng-container
      *ngIf="
        policy?.policyStatus === 'ACTIVE' &&
        policy?.policyFlags?.isEft === 'ENROLLED'
      "
    >
      <div class="bn-notice-content" *ngIf="autoPayForce && !suppressAutoPayAlertNotice">
        <app-bn-imp-notice
          [policy]="policy"
          [autoPayForce]="autoPayForce"
          [deductionDay]="deductionDay"
        ></app-bn-imp-notice>
      </div>
      <div class="bn-notice-content" *ngIf="autoPayAlert && !suppressAutoPayAlertNotice">
        <app-bn-alert-notice
          [policy]="policy"
          [autoPayAlert]="autoPayAlert"
          [deductionDay]="deductionDay"
        ></app-bn-alert-notice>
      </div>
    </ng-container>
    <div class="bn-pay-methods margin-bottom mb32">
      <div
        class="bn-paymethod bn-paymethod-l"
        *ngIf="!isACH && policy?.billingDetails[0]?.badCheckCount === 'N'"
      >
        <div
          class="bn-paymethod-item cursor-pointer margin-bottom mb8"
          [ngClass]="{ mb16: isAcmic }"
          (click)="onCheckingOrSavingsAccount()"
        >
          <div class="bn-paymethod-item-title">Checking / savings account</div>
          <ng-container *ngIf="isAcmic; else maArrowIcon">
            <img src="assets/img/images/acmic-right-arrow-blue.svg" />
          </ng-container>
          <ng-template #maArrowIcon>
            <img src="assets/img/images/icon-simple-arrow-right-red.svg" />
          </ng-template>
        </div>
        <div class="bn-manage-link" (click)="navigateToMyAccount()">
          Manage checking / savings account
        </div>
      </div>
      <div class="bn-paymethod" *ngIf="!isCCDC">
        <div
          class="bn-paymethod-item cursor-pointer margin-bottom mb8 ele-custom-loader"
          (click)="!loader && onPayByCardBilling()"
          [ngClass]="{ mb16: isAcmic, custom_loader: loader }"
        >
          <div class="bn-paymethod-item-title">Credit / debit card</div>
          <ng-container *ngIf="isAcmic; else maArrowIcon">
            <img src="assets/img/images/acmic-right-arrow-blue.svg" />
          </ng-container>
          <ng-template #maArrowIcon>
            <img src="assets/img/images/icon-simple-arrow-right-red.svg" />
          </ng-template>
        </div>
        <div class="bn-manage-link" (click)="navigateToMyAccount()">
          Manage credit / debit card
        </div>
      </div>
    </div>
  </div>
</div>
